import * as React from "react";
const SvgMastercard = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 37,
	height: 24,
	fill: "none",
	viewBox: "0 0 37 24",
	id: "mastercard_icon",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fill: "#FF5F00",
	d: "M23.335 3.354h-9.632v17.287h9.632z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#EB001B",
	d: "M14.315 11.998c0-3.36 1.56-6.567 4.19-8.644C13.733-.402 6.822.423 3.061 5.217-.698 9.982.127 16.884 4.928 20.641a10.99 10.99 0 0 0 13.607 0 11 11 0 0 1-4.22-8.643"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#F79E1B",
	d: "M36.33 11.997c0 6.078-4.922 10.995-11.007 10.995-2.477 0-4.862-.825-6.788-2.352 4.77-3.756 5.595-10.658 1.834-15.453-.55-.672-1.162-1.314-1.834-1.833 4.77-3.756 11.71-2.932 15.441 1.863a10.87 10.87 0 0 1 2.355 6.78Zm-1.039 6.811v-.367h.153v-.06h-.367v.06h.153v.367zm.704 0v-.428h-.123l-.122.306-.122-.306h-.123v.428h.092v-.336l.122.275h.092l.122-.275v.336z"
}));
export { SvgMastercard as ReactComponent };
